import script from "./recommend-card.vue?vue&type=script&setup=true&lang=js"
export * from "./recommend-card.vue?vue&type=script&setup=true&lang=js"

import "./recommend-card.vue?vue&type=style&index=0&id=29ab4c5e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29ab4c5e"]])

export default __exports__